<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtrowanie
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Dział</label>
          <v-select
            :value="departmentFilter"
            :options="departmentOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:departmentFilter', val)"
          />
        </b-col>
        <b-col
          v-if="isAdmin"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Trener</label>
          <v-select
            :value="trainerFilter"
            :options="trainerOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:trainerFilter', val)"
          />
        </b-col>
        <b-col
          v-if="isAdmin"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Status szkolenia</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col
          v-if="isAdmin || isFordPoland || isManager"
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Uczestnik</label>
          <v-select
            :value="userFilter"
            :options="userOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:userFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import userRoleMixin from '@/mixins/userRoleMixin'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  mixins: [userRoleMixin],
  props: {
    departmentFilter: {
      type: [String, null],
      default: null,
    },
    departmentOptions: {
      type: Array,
      required: true,
    },
    statusFilter: {
      type: [String, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    trainerFilter: {
      type: [String, null],
      default: null,
    },
    trainerOptions: {
      type: Array,
      required: true,
    },
    userFilter: {
      type: [Number, null],
      default: null,
    },
    userOptions: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
